import axios from "../axiosInstance";
import { UnenrollRequestParams, UnenrollResponse } from "./types";

export const unenrollCourse = async (
  params: UnenrollRequestParams,
): Promise<UnenrollResponse> => {
  const response = await axios.delete<UnenrollResponse>(
    `/api/learning-center/enrollments/${params.enrollmentId}`,
  );
  return response.data;
};
